<template>
  <div>
    <div v-if="!confirm" class="form-group row py-2">
      <label for="mobile_phone_number" class="col-md-4 col-form-label text-md-right">
        Bekreftelseskode:
      </label>
      <div class="col-md-6">
        <div class="input-group">
          <input
            id="code"
            name="code"
            type="text"
            class="form-control"
            v-model="code"
            required=""
            autofocus=""
          >
        </div>
      </div>
    </div>
    <div v-if="error !== undefined" class="alert alert-danger" role="alert">

        {{ error }}

    </div>
    <div v-if="message !== undefined" class=" py-2 pb-4 mb-2">
      <div class="alert alert-success" role="alert">

          {{ message }}

      </div>
    </div>
    <div v-if="!confirm"  class="form-group row py-2 pb-4">
      <div class="col-md-8 offset-md-4">
        <button @click="confirmCode" type="submit" class="btn btn-success">
          Bekreft mobilnummer
        </button>


      </div>
      <div class="col-md-8 offset-md-4">

        <btn @click="getCode" class="btn btn-link" >
          Jeg har ikke mottatt kode, send ny!
        </btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConfirmPhoneComponent',
  data: function () {
    return {
      code: '',
      confirm: false,
      error: undefined,
      message: undefined,
    }
  },
  mounted() {
  },
  methods: {
    getCode() {
      this.error = undefined
      this.message = undefined
      axios({
        url: `/register/confirm/phone`,
        method: 'GET',
      }).then(resp => {
        this.message = resp.data.message
      }).catch(err => {
        this.error = err.response.data.message
      })
    },
    confirmCode() {
      this.error = undefined
      this.message = undefined
      axios({
        url: `/register/confirm/phone`,
        method: 'PUT',
        data: {sms_key: this.code}
      }).then(resp => {
        this.message = resp.data.message
        this.confirm = true
      }).catch(err => {
        this.error = err.response.data.message
      })

    },
  }
}
</script>
